"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRecord = void 0;
/**
 * Validate an unknown value to determine if it's a record object.
 *
 * @example key value object is a record
 * ```ts
 * isRecord({ "key": "value" }) // true
 * ```
 * @example array is not a record
 * ```ts
 * isRecord([1, 2, 3]) // false
 * ```
 */
function isRecord(value) {
    return value !== null && typeof value === "object" && !Array.isArray(value);
}
exports.isRecord = isRecord;
